<template>
  <section class="section-container" v-if="!is_supplier">
    <div class="content-wrapper">
      <div class="content-heading">
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-6">{{ $t('parts.title') }}</div>
            <div class="col-md-6 text-right">
              <button
                class="btn btn-sm btn-warning"
                type="button"
                :disabled="updateBtnDisabled"
                @click="update_parts"
              >{{ $t('parts.add-new') }}</button>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xl-12" v-if="!loader">
          <div class="card">
            <div class="card-body">
              <div class="dataTables_wrapper table-responsive container-fluid dt-bootstrap4 no-footer">
                <datatablebuttons/>
                <search @make_search="make_search"/>
                <div class="table-responsive">
                  <table class="table table-striped dataTable my-4 w-100" id="parts">
                    <thead>
                    <tr>
                      <th>
                        <div class="checkbox c-checkbox">
                          <label class="mb-0 p">
                            <input class="select-box" type="checkbox" v-model="selectAll">
                            <span class="fa fa-check"></span>
                          </label>
                        </div>
                      </th>
                      <th
                        :class="{
                              'sorting_asc': ordering === 'code',
                              'sorting_desc': ordering === '-code'}"
                        @click="order('code')">{{ $t('parts.code') }}
                      </th>
                      <th
                        :class="{
                              'sorting_asc': ordering === 'barcode',
                              'sorting_desc': ordering === '-barcode'}"
                        @click="order('barcode')">{{ $t('parts.barcode') }}
                      </th>
                      <th
                        :class="{
                              'sorting_asc': ordering === 'name',
                              'sorting_desc': ordering === '-name'}"
                        @click="order('name')">{{ $t('parts.name') }}
                      </th>
                      <th
                        :class="{
                              'sorting_asc': ordering === 'unit',
                              'sorting_desc': ordering === '-unit'}"
                        @click="order('unit')">{{ $t('parts.unit') }}
                      </th>
                      <th
                        :class="{
                              'sorting_asc': ordering === 'code_names',
                              'sorting_desc': ordering === '-code_names'}"
                        @click="order('code_names')">{{ $t('parts.codes') }}
                      </th>
                      <th
                        :class="{
                              'sorting_asc': ordering === 'part_type',
                              'sorting_desc': ordering === '-part_type'}"
                        @click="order('part_type')">{{ $t('parts.type') }}
                      </th>
                      <th
                        :class="{
                              'sorting_asc': ordering === 'is_active',
                              'sorting_desc': ordering === '-is_active'}"
                        @click="order('is_active')">{{ $t('parts.status') }}
                      </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr :key="row.id" class="gradeX" v-for="row in rows">
                      <td>
                        <div class="checkbox c-checkbox">
                          <label class="mb-0">
                            <input :value="row.id" class="select-box" type="checkbox" v-model="selected">
                            <span class="fa fa-check"></span>
                          </label>
                        </div>
                      </td>
                      <td>{{ row.code }}</td>
                      <td>{{ row.barcode }}</td>
                      <td>{{ row.name }}</td>
                      <td>{{ row.unit_code }}</td>
                      <td>{{ row.codes_tags }}</td>
                      <td>{{ row.part_type_name }}</td>
                      <td>{{ row.is_active ? 'Active' : 'Disabled' }}</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
                <pagination
                  :page="page"
                  :pages="pages"
                  :count="count"
                  :from="(page - 1) * page_size + 1"
                  :to="(page - 1) * page_size + rows.length"
                  @paginate="paginate"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-12 text-center" v-if="loader">
          <div class="card">
            <div class="card-body loader-demo d-flex align-items-center justify-content-center">
              <div class="ball-beat">
                <div></div>
                <div></div>
                <div></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import api from '@/api'
import Datatablebuttons from '@/components/Datatablebuttons.vue'
import message from '@/message'
import Pagination from '@/components/Pagination.vue'
import Search from '@/components/Search.vue'

const getData = (route, next) => {
  const search = route.query.search
  const ordering = route.query.ordering || 'code'
  const page = parseInt(route.query.page) || 1

  let stored_page_size = JSON.parse(localStorage.getItem('etend.page_size'))
    || {}
  let page_size = route.query.page_size
    || stored_page_size[route.name]
    || process.env.DEFAULT_PAGE_SIZE

  Promise.all([
    api.get(`/parts/`, {
      params: {
        search: search,
        ordering: ordering,
        page: page,
        page_size: page_size
      }
    })
  ])
    .then(([parts]) => {
      let rowsData = []
      let rows = parts.data.results

      rows.forEach(row => {
        rowsData.push({
          0: row.id,
          1: '-',
          2: row.code,
          3: row.barcode,
          4: row.name,
          5: row.codes_tags,
          7: row.part_type_name,
          8: row.is_active ? 'Active' : 'Disabled'
        })
      })

      next({
        rows: rows,
        rowsData: rowsData,
        search: search,
        ordering: ordering,
        pages: parts.data.pages,
        count: parts.data.count,
        page: page,
        page_size: page_size
      })
    })
}

export default {
  components: {
    datatablebuttons: Datatablebuttons,
    pagination: Pagination,
    search: Search
  },
  data() {
    return {
      rows: [],
      rowsData: [],
      search: null,
      ordering: null,
      interval: null,
      pages: null,
      page_size: null,
      count: null,
      page: null,
      module_log_id: null,
      loader: false,
      updateBtnDisabled: false,
      selected: [],
      columns: [
        this.$i18n.t('parts.picture'),
        this.$i18n.t('parts.code'),
        this.$i18n.t('parts.barcode'),
        this.$i18n.t('parts.name'),
        this.$i18n.t('parts.codes'),
        this.$i18n.t('parts.type'),
        this.$i18n.t('parts.status')
      ]
    }
  },

  mounted() {
    this.$parent.menu = 'setup'
    this.$parent.submenu = 'parts'
    this.$i18n.locale = this.$store.getters.language
  },

  computed: {
    is_administrator() {
      return this.$store.getters.user_group === 'Administrator'
    },
    is_contractor() {
      return this.$store.getters.user_group === 'Contractor'
    },
    is_supplier() {
      return this.$store.getters.user_group === 'Supplier'
    },
    selectAll: {
      get: function () {
        return this.rows ? this.selected.length === this.rows.length : false
      },
      set: function (value) {
        let selected = []
        if (value) {
          this.rows.forEach(function (p) {
            selected.push(p.id)
          })
        }
        this.selected = selected
      }
    }
  },

  methods: {
    remove_part(id, index) {
      this.$swal({
        type: 'warning',
        title: this.$i18n.t('parts.are-you-sure'),
        text: this.$i18n.t('parts.are-you-sure-text-cancel'),
        showCancelButton: true
      })
        .then((choice) => {
          if (choice.value) {
            api.patch(`/parts/${id}/`, {is_deleted: true, is_active: false})
              .then(() => {
                message.success(this.$i18n.t('parts.deleted'))
                this.$delete(this.rows, index)
              })
              .catch(() => {
                message.error(this.$i18n.t('parts.forbidden'))
              })
          }
        })
    },
    update_parts() {
      if (this.updateBtnDisabled) return;

      this.updateBtnDisabled = true
      api.post('/setup/bc-sync')
        .then(resp => {
          if (resp.data.status === 'running') {
            message.success(this.$i18n.t('parts.sync-bc-success-running'))
          } else {
            message.success(this.$i18n.t('parts.sync-bc-success-started'))
          }
        })
        .catch(() => {
          message.error(this.$i18n.t('parts.sync-bc-error'))
        })
        .finally(() => {
          this.updateBtnDisabled = false
        })
    },
    order(o) {
      this.$parent.order(o, this.search, this.ordering)
    },
    paginate(p) {
      this.$parent.paginate(p, this.search, this.ordering)
    },
    make_search() {
      this.$parent.make_search(this.search, this.ordering)
    }
  },
  beforeRouteEnter(to, from, next) {
    getData(to, data => {
      next(vm => {
        Object.assign(vm.$data, data)
      })
    })
  },
  beforeRouteUpdate(to, from, next) {
    getData(to, data => {
      Object.assign(this.$data, data)
      next()
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Parts.vue